<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
        <!-- Temporário: não colorir linhas -->
        <!-- :item-class="getRowColor" -->

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao">
              {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas
            </span>
          </template>

          <template v-slot:item.no_cidadao="{ item }">
            {{ item.no_cidadao || '-' }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            <template v-if="item.dt_nascimento">
              {{ formatDate(item.dt_nascimento) }}
              <br />
              ({{ item.idade || 0 }} {{ (item.idade || 0) > 1 ? 'anos' : 'ano' }})
            </template>
            <template v-else>-</template>
          </template>

          <template v-slot:item.no_mae="{ item }">
            {{ item.no_mae || '-' }}
          </template>

          <template v-slot:item.dt_admissao="{ item }">
            {{ item.dt_admissao ? formatDate(item.dt_admissao) : '-' }}
          </template>

          <template v-slot:item.dt_conclusao="{ item }">
            {{ item.dt_conclusao ? formatDate(item.dt_conclusao) : '-' }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Endereço</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf || '-' }}</td>
                    <td>{{ item.nu_cns || '-' }}</td>
                    <td>{{ item.ds_endereco || item.endereco || '-' }}</td>
                    <td>{{ item.micro_area || '-' }}</td>
                    <td>{{ item.no_profissional || '-' }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>Admissão</th>
                    <th>Cadastro Individual</th>
                    <th>Atendimentos</th>
                    <th>Ações</th>
                    <th>Agendamentos</th>
                    <th>Conclusão</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-interna-acompanhamento-item"
                        @click="openModalAdmissao(item)"
                      >
                        Admissão
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="getCadastroInfo(item).data"
                        class="table-interna-acompanhamento-item"
                        @click="openModalCadastro(item)"
                      >
                        {{ formatDate(getCadastroInfo(item).data) }}
                        <br />
                        <div>
                          {{ getCadastroInfo(item).qtd }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="getUltimaDataAtendimentos(item)"
                        class="table-interna-acompanhamento-item"
                        @click="openModalAtendimentos(item)"
                      >
                        {{ formatDate(getUltimaDataAtendimentos(item)) }}
                        <br />
                        <div>
                          {{ getListaAtendimentos(item).length }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="getUltimaDataAcoes(item)"
                        class="table-interna-acompanhamento-item"
                        @click="openModalAcoes(item)"
                      >
                        {{ formatDate(getUltimaDataAcoes(item)) }}
                        <br />
                        <div>
                          {{ getListaAcoes(item).length }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="getUltimaDataAgendamentos(item)"
                        class="table-interna-acompanhamento-item"
                        @click="openModalAgendamentos(item)"
                      >
                        {{ formatDate(getUltimaDataAgendamentos(item)) }}
                        <br />
                        <div>
                          {{ getListaAgendamentos(item).length }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-interna-acompanhamento-item"
                        @click="openModalConclusao(item)"
                      >
                        Conclusão
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Modal Atendimento Individual -->
      <b-modal
        id="modal-atendimentos-caps"
        ref="modalAtendimentos"
        v-model="modalAtendimentos.show"
        title="Atendimento Individual"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> Atendimento Individual </template>
        <div class="modal-caps-body" v-if="modalAtendimentos.item != null">
          <table class="table table-interna">
            <thead>
              <tr>
                <th>Nº</th>
                <th>Atendimento</th>
                <th>Equipe</th>
                <th>CBO</th>
                <th>Ficha</th>
              </tr>
            </thead>
            <tbody v-if="modalAtendimentos.items && modalAtendimentos.items.length > 0">
              <tr
                v-for="(atend, indexAtend) in modalAtendimentos.items"
                :key="indexAtend"
              >
                <td>{{ indexAtend + 1 }}</td>
                <td>
                  {{
                    atend.dt_atendimento || atend.dt_atend || atend.dt_proced
                      ? formatDate(
                          atend.dt_atendimento || atend.dt_atend || atend.dt_proced
                        )
                      : '-'
                  }}
                </td>
                <td>{{ atend.no_equipe || atend.equipe || '-' }}</td>
                <td>
                  {{ atend.nu_cbo || atend.co_cbo || atend.no_cbo || '-' }}
                </td>
                <td>
                  {{
                    atend.ficha ||
                    atend.no_ficha ||
                    atend.co_proced ||
                    atend.ds_acao ||
                    '-'
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">Nenhum atendimento individual registrado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>

      <!-- Modal Ações / Procedimentos -->
      <b-modal
        id="modal-acoes-caps"
        ref="modalAcoes"
        v-model="modalAcoes.show"
        title="Procedimentos"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> Procedimentos </template>
        <div class="modal-caps-body" v-if="modalAcoes.item != null">
          <table class="table table-interna">
            <thead>
              <tr>
                <th>Data</th>
                <th>Unidade de Saúde</th>
                <th>CBO</th>
                <th>Ficha</th>
                <th>Profissional</th>
              </tr>
            </thead>
            <tbody v-if="modalAcoes.items && modalAcoes.items.length > 0">
              <tr
                v-for="(acao, indexAcao) in modalAcoes.items"
                :key="indexAcao"
              >
                <td>
                  {{
                    acao.dt_proced || acao.dt_atendimento || acao.dt_procedimento
                      ? formatDate(
                          acao.dt_proced ||
                            acao.dt_atendimento ||
                            acao.dt_procedimento
                        )
                      : '-'
                  }}
                </td>
                <td>
                  {{
                    acao.no_unidade_saude ||
                    acao.unidade_saude ||
                    modalAcoes.item.no_unidade_saude ||
                    '-'
                  }}
                </td>
                <td>{{ acao.nu_cbo || acao.co_cbo || acao.no_cbo || '-' }}</td>
                <td>
                  {{
                    acao.co_proced ||
                    acao.ds_acao ||
                    acao.ficha ||
                    acao.no_ficha ||
                    '-'
                  }}
                </td>
                <td>
                  {{
                    acao.no_profissional ||
                    acao.profissional ||
                    acao.cns_prof ||
                    '-'
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">Nenhum procedimento registrado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>

      <!-- Modal Admissão -->
      <b-modal
        id="modal-admissao-caps"
        ref="modalAdmissao"
        v-model="modalAdmissao.show"
        title="Admissão"
        centered
        hide-footer
        size="lg"
        modal-class="modal-caps-form"
      >
        <template #modal-title> Admissão </template>
        <div class="modal-caps-body" v-if="modalAdmissao.item != null">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Data de Admissão</label>
              <the-mask
                :mask="['##/##/####']"
                v-model="modalAdmissao.form.dt_admissao"
                class="form-control"
                placeholder="dd/mm/aaaa"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Prontuário</label>
              <input
                type="text"
                class="form-control"
                v-model="modalAdmissao.form.prontuario"
                placeholder="Prontuário"
              />
            </div>
            <div class="col-md-12 mb-3">
              <label class="modal-caps-label">Endereço completo</label>
              <input
                type="text"
                class="form-control"
                :value="modalAdmissao.form.endereco"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Morador de rua</label>
              <input
                type="text"
                class="form-control"
                :value="modalAdmissao.form.situacao_rua"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Residente no município</label>
              <input
                type="text"
                class="form-control"
                :value="modalAdmissao.form.residente_municipio"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Origem do Usuário</label>
              <vue-select
                :options="getOpcoesOrigem(modalAdmissao.item)"
                label="text"
                :reduce="(opcao) => opcao.value"
                v-model="modalAdmissao.form.origem_usuario"
                placeholder="Selecione"
                :clearable="true"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">CID Principal</label>
              <input
                type="text"
                class="form-control"
                v-model="modalAdmissao.form.cid_principal"
                placeholder="CID Principal"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">CID Causas Associadas</label>
              <input
                type="text"
                class="form-control"
                v-model="modalAdmissao.form.cid_causas_associadas"
                placeholder="CID Causas Associadas"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Destino do Usuário</label>
              <vue-select
                :options="getOpcoesDestino(modalAdmissao.item)"
                label="text"
                :reduce="(opcao) => opcao.value"
                v-model="modalAdmissao.form.destino_usuario"
                placeholder="Selecione"
                :clearable="true"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="modal-caps-actions">
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="modalAdmissao.saving"
              @click="fecharModalAdmissao"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="modalAdmissao.saving"
              @click="salvarModalAdmissao"
            >
              <b-spinner small class="mr-1" v-if="modalAdmissao.saving" />
              Salvar
            </button>
          </div>
        </div>
      </b-modal>

      <!-- Modal Cadastro -->
      <b-modal
        id="modal-cadastro-caps"
        ref="modalCadastro"
        v-model="modalCadastro.show"
        title="Cadastro"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> Cadastro </template>
        <div class="modal-caps-body" v-if="modalCadastro.item != null">
          <table class="table table-interna">
            <thead>
              <tr>
                <th>Campos do Cadastro individual ainda não preenchidos</th>
              </tr>
            </thead>
            <tbody v-if="modalCadastro.isCompleto">
              <tr>
                <td>Parabéns &#128079; CI completo.</td>
              </tr>
            </tbody>
            <tbody v-else-if="modalCadastro.items && modalCadastro.items.length > 0">
              <tr v-for="(campo, indexCampo) in modalCadastro.items" :key="indexCampo">
                <td>{{ campo.campo }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td>
                  Após o preenchimento da ficha simplificada do cidadão,
                  recomenda-se preencher também o Cadastro Individual (CI)
                  completo. Isso garante a qualidade, completude e integridade
                  do cadastro.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>

      <!-- Modal Conclusão -->
      <b-modal
        id="modal-conclusao-caps"
        ref="modalConclusao"
        v-model="modalConclusao.show"
        title="Conclusão"
        centered
        hide-footer
        size="lg"
        modal-class="modal-caps-form"
      >
        <template #modal-title> Conclusão </template>
        <div class="modal-caps-body" v-if="modalConclusao.item != null">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Data de Admissão</label>
              <the-mask
                :mask="['##/##/####']"
                v-model="modalConclusao.form.dt_admissao"
                class="form-control"
                placeholder="dd/mm/aaaa"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Prontuário</label>
              <input
                type="text"
                class="form-control"
                v-model="modalConclusao.form.prontuario"
                placeholder="Prontuário"
              />
            </div>
            <div class="col-md-12 mb-3">
              <label class="modal-caps-label">Endereço completo</label>
              <input
                type="text"
                class="form-control"
                :value="modalConclusao.form.endereco"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Morador de rua</label>
              <input
                type="text"
                class="form-control"
                :value="modalConclusao.form.situacao_rua"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Residente no município</label>
              <input
                type="text"
                class="form-control"
                :value="modalConclusao.form.residente_municipio"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Origem do Usuário</label>
              <vue-select
                :options="getOpcoesOrigem(modalConclusao.item)"
                label="text"
                :reduce="(opcao) => opcao.value"
                v-model="modalConclusao.form.origem_usuario"
                placeholder="Selecione"
                :clearable="true"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">CID Principal</label>
              <input
                type="text"
                class="form-control"
                v-model="modalConclusao.form.cid_principal"
                placeholder="CID Principal"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">CID Causas Associadas</label>
              <input
                type="text"
                class="form-control"
                v-model="modalConclusao.form.cid_causas_associadas"
                placeholder="CID Causas Associadas"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Destino do Usuário</label>
              <vue-select
                :options="getOpcoesDestinoConclusao(modalConclusao.item)"
                label="text"
                :reduce="(opcao) => opcao.value"
                v-model="modalConclusao.form.destino_usuario"
                placeholder="Selecione"
                :clearable="true"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="modal-caps-label">Data da Conclusão</label>
              <the-mask
                :mask="['##/##/####']"
                v-model="modalConclusao.form.dt_conclusao"
                class="form-control"
                placeholder="dd/mm/aaaa"
              />
            </div>
          </div>
          <div class="modal-caps-actions">
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="modalConclusao.saving"
              @click="fecharModalConclusao"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="modalConclusao.saving"
              @click="salvarModalConclusao"
            >
              <b-spinner small class="mr-1" v-if="modalConclusao.saving" />
              Salvar
            </button>
          </div>
        </div>
      </b-modal>

      <!-- Modal Agendamentos -->
      <b-modal
        id="modal-agendamentos-caps"
        ref="modalAgendamentos"
        v-model="modalAgendamentos.show"
        title="Agendamentos"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> Agendamentos </template>
        <div class="modal-caps-body" v-if="modalAgendamentos.item != null">
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import { TheMask } from 'vue-the-mask'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'TabelaCadastros',
  components: {
    TheMask,
    'vue-select': VueSelect,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '160px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'Admissão',
          align: 'start',
          filterable: false,
          value: 'dt_admissao',
          width: '160px',
        },
        {
          text: 'Conclusão',
          align: 'start',
          filterable: false,
          value: 'dt_conclusao',
          width: '160px',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modalAtendimentos: {
        show: false,
        item: null,
        items: [],
      },
      modalAcoes: {
        show: false,
        item: null,
        items: [],
      },
      modalAdmissao: {
        show: false,
        item: null,
        saving: false,
        dt_admissao_original: null,
        form: {
          dt_admissao: '',
          prontuario: '',
          endereco: '',
          situacao_rua: '',
          residente_municipio: '',
          origem_usuario: null,
          cid_principal: '',
          cid_causas_associadas: '',
          destino_usuario: null,
        },
      },
      modalCadastro: {
        show: false,
        item: null,
        items: [],
        isCompleto: false,
      },
      modalConclusao: {
        show: false,
        item: null,
        saving: false,
        dt_admissao_original: null,
        form: {
          dt_admissao: '',
          prontuario: '',
          endereco: '',
          situacao_rua: '',
          residente_municipio: '',
          origem_usuario: null,
          cid_principal: '',
          cid_causas_associadas: '',
          destino_usuario: null,
          dt_conclusao: '',
        },
      },
      modalAgendamentos: {
        show: false,
        item: null,
      },
      opcoesOrigemUsuario: [
        { value: '01', text: '01 - Atenção Básica' },
        { value: '02', text: '02 - Pronto Atendimento / UPA' },
        { value: '03', text: '03 - Hospital' },
        { value: '04', text: '04 - Demanda Espontânea' },
        { value: '05', text: '05 - Outros CAPS' },
      ],
      opcoesDestinoUsuario: [
        { value: '00', text: '00 - Permanência' },
        { value: '01', text: '01 - CONTINUIDADE DO ACOMP. EM OUTRO CAPS' },
        { value: '02', text: '02 - CONTINUIDADE DE ACOMP. NA ATENÇÃO BASICA' },
        { value: '03', text: '03 - ALTA' },
        { value: '04', text: '04 - OBITO' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler() {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.cadastros && Array.isArray(this.cadastros)) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
      return []
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca no Nome.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = (this.cadastros || []).filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value] || '').toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      // Temporário: não colorir linhas (descomente o return abaixo para reativar)
      return ''
      // return `table-row-color-${Functions.printTableRow(item)}`
    },

    /**
     * Faz parse de campo JSON string ou array
     * @param {*} value
     * @returns {Array}
     */
    parseJsonField(value) {
      if (!value) return []
      if (Array.isArray(value)) return value
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },

    /**
     * Retorna a data mais recente de uma lista de registros
     * @param {Array} lista
     * @param {Array} camposData
     * @returns {String|null}
     */
    getUltimaDataLista(lista, camposData) {
      if (!lista || !lista.length) return null

      let maxDate = null
      let maxDateStr = null

      lista.forEach((registro) => {
        camposData.forEach((campo) => {
          const valor = registro[campo]
          if (!valor) return

          const data = new Date(valor)
          if (!isNaN(data.getTime()) && (!maxDate || data > maxDate)) {
            maxDate = data
            maxDateStr = valor
          }
        })
      })

      return maxDateStr
    },

    /**
     * Retorna informações do cadastro para o botão da tabela
     * @param {Object} item
     * @returns {{ data: String|null, qtd: Number }}
     */
    getCadastroInfo(item) {
      const items = this.getListaCadastroCampos(item)
      const percent = item.percent_fci_completa
      const isCompleto = percent != null && Number(percent) >= 100
      const data = item.dt_admissao || null
      const qtd = isCompleto ? 1 : items.length || (data ? 1 : 0)

      return { data, qtd }
    },

    /**
     * Retorna os campos do cadastro individual ainda não preenchidos
     * @param {Object} item
     * @returns {Array<{ campo: String, valor: String }>}
     */
    getListaCadastroCampos(item) {
      const fci = item.fci_completa

      if (!fci) {
        return []
      }

      try {
        const parsed = typeof fci === 'string' ? JSON.parse(fci) : fci

        if (Array.isArray(parsed)) {
          return parsed.map((entry, index) => {
            if (entry && typeof entry === 'object') {
              return {
                campo:
                  entry.campo ||
                  entry.label ||
                  entry.nome ||
                  `Campo ${index + 1}`,
                valor: entry.valor || entry.value || 'Não preenchido',
              }
            }

            return {
              campo: String(entry),
              valor: 'Não preenchido',
            }
          })
        }

        if (parsed && typeof parsed === 'object') {
          return Object.keys(parsed).map((campo) => ({
            campo,
            valor:
              parsed[campo] != null && parsed[campo] !== ''
                ? parsed[campo]
                : 'Não preenchido',
          }))
        }
      } catch (e) {
        return [
          {
            campo: String(fci).replace(/^\{|\}$/g, ''),
            valor: 'Não preenchido',
          },
        ]
      }

      return []
    },

    /**
     * Retorna a lista de atendimentos individuais do paciente
     * @param {Object} item
     * @returns {Array}
     */
    getListaAtendimentos(item) {
      let atendimentos = this.parseJsonField(item.fai)
      if (!atendimentos.length) {
        atendimentos = this.parseJsonField(item.atendimentos)
      }
      if (!atendimentos.length) {
        atendimentos = this.parseJsonField(item.fais)
      }
      return atendimentos
    },

    /**
     * Retorna a data do último atendimento individual
     * @param {Object} item
     * @returns {String|null}
     */
    getUltimaDataAtendimentos(item) {
      return this.getUltimaDataLista(this.getListaAtendimentos(item), [
        'dt_atendimento',
        'dt_atend',
        'dt_proced',
      ])
    },

    /**
     * Retorna a lista de ações/procedimentos do paciente
     * @param {Object} item
     * @returns {Array}
     */
    getListaAcoes(item) {
      let acoes = this.parseJsonField(item.acoes)
      if (!acoes.length) {
        acoes = this.parseJsonField(item.procedimentos)
      }
      if (!acoes.length) {
        acoes = this.parseJsonField(item.fps)
      }
      return acoes
    },

    /**
     * Retorna a data da última ação/procedimento
     * @param {Object} item
     * @returns {String|null}
     */
    getUltimaDataAcoes(item) {
      return this.getUltimaDataLista(this.getListaAcoes(item), [
        'dt_proced',
        'dt_atendimento',
        'dt_procedimento',
      ])
    },

    /**
     * Retorna a lista de agendamentos do paciente
     * @param {Object} item
     * @returns {Array}
     */
    getListaAgendamentos(item) {
      return this.parseJsonField(item.agendamentos)
    },

    /**
     * Retorna a data do último agendamento
     * @param {Object} item
     * @returns {String|null}
     */
    getUltimaDataAgendamentos(item) {
      return this.getUltimaDataLista(this.getListaAgendamentos(item), [
        'dt_agendamento',
        'dt_consulta',
        'dt_atendimento',
        'data',
      ])
    },

    /**
     * Abre o modal de Atendimento Individual
     * @param {Object} item
     */
    openModalAtendimentos(item) {
      this.modalAtendimentos.item = item
      this.modalAtendimentos.items = this.getListaAtendimentos(item)
      this.modalAtendimentos.show = true
    },

    /**
     * Abre o modal de Ações (Procedimentos)
     * @param {Object} item
     */
    openModalAcoes(item) {
      this.modalAcoes.item = item
      this.modalAcoes.items = this.getListaAcoes(item)
      this.modalAcoes.show = true
    },

    /**
     * Abre o modal de Admissão
     * @param {Object} item
     */
    openModalAdmissao(item) {
      this.modalAdmissao.item = item
      this.modalAdmissao.dt_admissao_original = item.dt_admissao || null
      this.modalAdmissao.form = this.buildFormAdmissaoConclusao(item)
      this.modalAdmissao.show = true
    },

    /**
     * Fecha o modal de Admissão
     */
    fecharModalAdmissao() {
      if (this.modalAdmissao.saving) return
      this.modalAdmissao.show = false
    },

    /**
     * Salva o modal de Admissão
     */
    async salvarModalAdmissao() {
      if (this.modalAdmissao.saving || !this.modalAdmissao.item) return

      const payload = Functions.buildPayloadAdmissao({
        item: this.modalAdmissao.item,
        form: this.modalAdmissao.form,
        dtAdmissaoOriginal: this.modalAdmissao.dt_admissao_original,
        opcoesOrigem: this.getOpcoesOrigem(this.modalAdmissao.item),
        opcoesDestino: this.getOpcoesDestino(this.modalAdmissao.item),
        quemAtualizou: this.$store.state.username || '',
      })

      this.modalAdmissao.saving = true
      try {
        await Functions.salvarAdmissaoConclusao(payload)
        this.$toast.success('Admissão salva com sucesso!', 'Sucesso:', {
          position: 'topRight',
        })
        this.modalAdmissao.show = false
        this.$emit('saved', { tipo: 'admissao', payload })
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Erro ao salvar admissão.'
        this.$toast.error(message, 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.modalAdmissao.saving = false
      }
    },

    /**
     * Abre o modal de Cadastro
     * @param {Object} item
     */
    openModalCadastro(item) {
      this.modalCadastro.item = item
      const percent = item.percent_fci_completa
      this.modalCadastro.isCompleto =
        percent != null && Number(percent) >= 100
      this.modalCadastro.items = this.getListaCadastroCampos(item)
      this.modalCadastro.show = true
    },

    /**
     * Abre o modal de Conclusão
     * @param {Object} item
     */
    openModalConclusao(item) {
      this.modalConclusao.item = item
      this.modalConclusao.dt_admissao_original = item.dt_admissao || null
      const form = this.buildFormAdmissaoConclusao(item)
      this.modalConclusao.form = {
        ...form,
        dt_conclusao: this.formatDateBr(item.dt_conclusao),
        destino_usuario:
          form.destino_usuario && form.destino_usuario !== '00'
            ? form.destino_usuario
            : null,
      }
      this.modalConclusao.show = true
    },

    /**
     * Fecha o modal de Conclusão
     */
    fecharModalConclusao() {
      if (this.modalConclusao.saving) return
      this.modalConclusao.show = false
    },

    /**
     * Salva o modal de Conclusão
     */
    async salvarModalConclusao() {
      if (this.modalConclusao.saving || !this.modalConclusao.item) return

      if (
        !this.modalConclusao.form.destino_usuario ||
        this.modalConclusao.form.destino_usuario === '00'
      ) {
        this.$toast.warning(
          'Selecione um destino diferente de Permanência.',
          'Atenção:',
          { position: 'topRight' }
        )
        return
      }

      if (!this.modalConclusao.form.dt_conclusao) {
        this.$toast.warning(
          'Informe a data da conclusão.',
          'Atenção:',
          { position: 'topRight' }
        )
        return
      }

      const payload = Functions.buildPayloadConclusao({
        item: this.modalConclusao.item,
        form: this.modalConclusao.form,
        dtAdmissaoOriginal: this.modalConclusao.dt_admissao_original,
        opcoesOrigem: this.getOpcoesOrigem(this.modalConclusao.item),
        opcoesDestino: this.getOpcoesDestinoConclusao(this.modalConclusao.item),
        quemAtualizou: this.$store.state.username || '',
      })

      this.modalConclusao.saving = true
      try {
        await Functions.salvarAdmissaoConclusao(payload)
        this.$toast.success('Conclusão salva com sucesso!', 'Sucesso:', {
          position: 'topRight',
        })
        this.modalConclusao.show = false
        this.$emit('saved', { tipo: 'conclusao', payload })
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Erro ao salvar conclusão.'
        this.$toast.error(message, 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.modalConclusao.saving = false
      }
    },

    /**
     * Monta o formulário compartilhado de Admissão/Conclusão
     * @param {Object} item
     * @returns {Object}
     */
    buildFormAdmissaoConclusao(item) {
      const cidCausas = this.getCidCausasAssociadasFromItem(item)

      return {
        dt_admissao: this.formatDateBr(item.dt_admissao),
        prontuario: this.getProntuario(item),
        endereco: this.getEnderecoCompleto(item),
        situacao_rua: this.formatSimNao(item.st_morador_rua),
        residente_municipio: this.formatSimNao(
          item.ativo_territorio ?? item.residente_municipio
        ),
        origem_usuario: this.normalizeSelectValue(
          item.co_origem || item.origem_usuario
        ),
        cid_principal: this.normalizeSelectValue(
          item.co_cid_principal || item.cid_principal
        ) || '',
        cid_causas_associadas: cidCausas.value || '',
        destino_usuario: this.normalizeSelectValue(
          item.co_destino || item.destino_usuario
        ),
      }
    },

    /**
     * Extrai o primeiro CID de causas associadas do item da API
     * @param {Object} item
     * @returns {{ value: String|null, label: String|null }}
     */
    getCidCausasAssociadasFromItem(item) {
      const raw = item?.cid_causas_associadas
      if (raw == null || raw === '' || raw === '[]') {
        return { value: null, label: null }
      }

      let lista = raw
      if (typeof raw === 'string') {
        try {
          lista = JSON.parse(raw)
        } catch (e) {
          const value = this.normalizeSelectValue(raw)
          return { value, label: value }
        }
      }

      if (!Array.isArray(lista) || !lista.length) {
        return { value: null, label: null }
      }

      const primeiro = lista[0]
      if (typeof primeiro === 'string' || typeof primeiro === 'number') {
        const value = this.normalizeSelectValue(primeiro)
        return { value, label: value }
      }

      if (primeiro && typeof primeiro === 'object') {
        const value = this.normalizeSelectValue(
          primeiro.co_cid ||
            primeiro.cid ||
            primeiro.value ||
            primeiro.codigo ||
            primeiro.id
        )
        const label =
          primeiro.ds_cid || primeiro.label || primeiro.text || value
        return { value, label }
      }

      return { value: null, label: null }
    },

    /**
     * Garante que o valor atual da API exista nas opções do select
     * @param {Array} options
     * @param {String|null} value
     * @param {String|null} label
     * @returns {Array}
     */
    ensureSelectOption(options, value, label) {
      const normalized = this.normalizeSelectValue(value)
      if (!normalized) return options

      const code = String(normalized)
      const text = label
        ? String(label).startsWith(code)
          ? String(label)
          : `${code} - ${label}`
        : code

      const index = options.findIndex((opcao) => String(opcao.value) === code)
      if (index === -1) {
        return [...options, { value: code, text }]
      }

      if (!label) return options

      return options.map((opcao, i) =>
        i === index ? { value: code, text } : { ...opcao }
      )
    },

    /**
     * Opções de origem com valor atual da API
     * @param {Object|null} item
     * @returns {Array}
     */
    getOpcoesOrigem(item) {
      return this.ensureSelectOption(
        this.opcoesOrigemUsuario,
        item?.co_origem || item?.origem_usuario,
        item?.ds_origem
      )
    },

    /**
     * Opções de destino com valor atual da API
     * @param {Object|null} item
     * @returns {Array}
     */
    getOpcoesDestino(item) {
      return this.ensureSelectOption(
        this.opcoesDestinoUsuario,
        item?.co_destino || item?.destino_usuario,
        item?.ds_destino
      )
    },

    /**
     * Opções de destino para Conclusão (sem Permanência)
     * @param {Object|null} item
     * @returns {Array}
     */
    getOpcoesDestinoConclusao(item) {
      return this.getOpcoesDestino(item).filter((opcao) => opcao.value !== '00')
    },

    /**
     * Normaliza valor de select para null quando vazio
     * @param {*} value
     * @returns {String|null}
     */
    normalizeSelectValue(value) {
      if (value == null || value === '') return null

      if (Array.isArray(value)) {
        return value.length ? this.normalizeSelectValue(value[0]) : null
      }

      if (typeof value === 'string') {
        const trimmed = value.trim()
        if (!trimmed || trimmed === '[]' || trimmed === '{}') return null

        if (trimmed.startsWith('[')) {
          try {
            const parsed = JSON.parse(trimmed)
            if (Array.isArray(parsed)) {
              return parsed.length
                ? this.normalizeSelectValue(parsed[0])
                : null
            }
          } catch (e) {
            return null
          }
        }

        return trimmed
      }

      if (typeof value === 'object') {
        return this.normalizeSelectValue(
          value.value ||
            value.codigo ||
            value.co_cid ||
            value.cid ||
            value.id ||
            null
        )
      }

      return String(value)
    },

    /**
     * Formata data para dd/mm/aaaa
     * @param {String|null} date
     * @returns {String}
     */
    formatDateBr(date) {
      if (!date) return ''
      if (String(date).includes('/')) return String(date).substring(0, 10)
      return this.formatDate(date) || ''
    },

    /**
     * Retorna o prontuário do paciente
     * @param {Object} item
     * @returns {String}
     */
    getProntuario(item) {
      return (
        item.nu_prontuario ||
        item.prontuario ||
        item.no_prontuario ||
        item.co_prontuario ||
        ''
      )
    },

    /**
     * Retorna o endereço completo do paciente
     * @param {Object} item
     * @returns {String}
     */
    getEnderecoCompleto(item) {
      return item.ds_endereco || item.endereco || '-'
    },

    /**
     * Retorna o label de situação de rua
     * @param {Object} item
     * @returns {String}
     */
    /**
     * Converte valor 1/0 da API para Sim/Não
     * @param {*} value
     * @returns {String}
     */
    formatSimNao(value) {
      if (value == null || value === '') return 'Não'

      const normalizado = String(value).trim().toUpperCase()
      if (['1', 'S', 'SIM', 'TRUE'].includes(normalizado)) return 'Sim'

      return 'Não'
    },

    /**
     * Abre o modal de Agendamentos
     * @param {Object} item
     */
    openModalAgendamentos(item) {
      this.modalAgendamentos.item = item
      this.modalAgendamentos.show = true
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}

.table-interna-acompanhamento-item {
  cursor: pointer;
  background-color: green;
  width: 100%;
  min-height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px;
  border: 1px solid #ccc;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
}

.modal-caps-label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
}

.modal-caps-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
</style>

<style lang="scss">
.modal-caps-form {
  .modal-content,
  .modal-body {
    overflow: visible !important;
  }

  .v-select {
    position: relative;
    z-index: 1;
  }

  .v-select.vs--open {
    z-index: 1055;
  }

  .vs__dropdown-menu {
    z-index: 1056;
    min-width: 100%;
    width: max-content;
    max-width: 480px;
    overflow-x: hidden;
  }

  .vs__dropdown-option {
    white-space: normal;
    word-break: break-word;
  }
}
</style>
